import { NgModule } from '@angular/core';
import { NullCheckPipe } from './null-check-pipe';

@NgModule({
    imports: [],
    declarations: [
        NullCheckPipe
    ],
    exports: [
        NullCheckPipe
    ]
})
export class NullCheckModule { }
